var _defs, _circle, _circle2, _circle3, _g, _g2, _g3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLoginIllustration(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 600 400",
    width: "100%",
    height: "100%",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "gradBlue",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#4f46e5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#2563eb"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "gradPurple",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#6366f1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#4338ca"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "glow1",
    cx: "50%",
    cy: "50%",
    r: "50%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#4f46e5",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#4f46e5",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "glow2",
    cx: "50%",
    cy: "50%",
    r: "50%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#6366f1",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#6366f1",
    stopOpacity: 0
  })))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 300,
    cy: 200,
    r: 180,
    fill: "url(#glow1)",
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "r",
    values: "180;200;180",
    dur: "10s",
    repeatCount: "indefinite"
  }))), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 150,
    cy: 350,
    r: 80,
    fill: "url(#gradBlue)",
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "r",
    values: "80;90;80",
    dur: "6s",
    repeatCount: "indefinite"
  }))), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 450,
    cy: 100,
    r: 60,
    fill: "url(#gradPurple)",
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "r",
    values: "60;70;60",
    dur: "7s",
    repeatCount: "indefinite"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(300, 200)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -150,
    y: -120,
    width: 300,
    height: 240,
    rx: 16,
    fill: "white",
    stroke: "#e2e8f0",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("text", {
    x: 0,
    y: -80,
    fontFamily: "Arial",
    fontSize: 24,
    fontWeight: "bold",
    textAnchor: "middle",
    fill: "#1e293b"
  }, "Welcome Back"), /*#__PURE__*/React.createElement("rect", {
    x: -110,
    y: -50,
    width: 220,
    height: 40,
    rx: 8,
    fill: "#f8fafc",
    stroke: "#e2e8f0",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("text", {
    x: -95,
    y: -25,
    fontFamily: "Arial",
    fontSize: 12,
    fill: "#94a3b8"
  }, "Email"), /*#__PURE__*/React.createElement("rect", {
    x: -110,
    y: 10,
    width: 220,
    height: 40,
    rx: 8,
    fill: "#f8fafc",
    stroke: "#e2e8f0",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("text", {
    x: -95,
    y: 35,
    fontFamily: "Arial",
    fontSize: 12,
    fill: "#94a3b8"
  }, "Password"), /*#__PURE__*/React.createElement("rect", {
    x: -110,
    y: 70,
    width: 220,
    height: 45,
    rx: 8,
    fill: "url(#gradBlue)"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "1;0.8;1",
    dur: "3s",
    repeatCount: "indefinite"
  })), /*#__PURE__*/React.createElement("text", {
    x: 0,
    y: 97,
    fontFamily: "Arial",
    fontSize: 16,
    fontWeight: "bold",
    textAnchor: "middle",
    fill: "white"
  }, "Login"))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 120,
    cy: 120,
    r: 15,
    fill: "url(#gradPurple)",
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "cy",
    values: "120;100;120",
    dur: "5s",
    repeatCount: "indefinite"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 480,
    cy: 280,
    r: 12,
    fill: "url(#gradBlue)",
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "cy",
    values: "280;300;280",
    dur: "4s",
    repeatCount: "indefinite"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M520,140 L530,130 L520,120 Z",
    fill: "url(#gradPurple)",
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "transform",
    values: "rotate(0,520,130); rotate(360,520,130)",
    attributeType: "XML",
    dur: "20s",
    repeatCount: "indefinite"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M80,270 L90,260 L80,250 Z",
    fill: "url(#gradBlue)",
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "transform",
    values: "rotate(0,80,260); rotate(360,80,260)",
    attributeType: "XML",
    dur: "15s",
    repeatCount: "indefinite"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 200,
    cy: 350,
    r: 4,
    fill: "url(#gradBlue)",
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "cy",
    values: "350;340;350",
    dur: "3s",
    repeatCount: "indefinite"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 400,
    cy: 50,
    r: 5,
    fill: "url(#gradPurple)",
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "cy",
    values: "50;60;50",
    dur: "4s",
    repeatCount: "indefinite"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 100,
    cy: 200,
    r: 3,
    fill: "url(#gradBlue)",
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "cx",
    values: "100;110;100",
    dur: "5s",
    repeatCount: "indefinite"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 500,
    cy: 200,
    r: 3,
    fill: "url(#gradPurple)",
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "cx",
    values: "500;490;500",
    dur: "6s",
    repeatCount: "indefinite"
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(300, 350)"
  }, /*#__PURE__*/React.createElement("text", {
    x: 0,
    y: 0,
    fontFamily: "Arial",
    fontSize: 28,
    fontWeight: "bold",
    textAnchor: "middle",
    fill: "url(#gradBlue)"
  }, "TALK HUB"), /*#__PURE__*/React.createElement("rect", {
    x: -60,
    y: 10,
    width: 120,
    height: 3,
    rx: 1.5,
    fill: "url(#gradPurple)",
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "width",
    values: "0;120;0",
    dur: "3s",
    repeatCount: "indefinite"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "x",
    values: "60;-60;60",
    dur: "3s",
    repeatCount: "indefinite"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoginIllustration);
export default __webpack_public_path__ + "static/media/login-illustration.081b09ab3d5b640b69c919b80105cce3.svg";
export { ForwardRef as ReactComponent };